import gql from 'graphql-tag';

const queryName = 'allUsers';

export const ALL_USERS = {
  queryName,
  queryBody: gql`
    query ${queryName} {
      ${queryName} {
        id
        firstName
        lastName
        email
        dateJoined
        lastLogin
        telephone
        isActive
        roles{
          name
        }
      }
    }
  `,
};
